import Offers from './Offers';

export default Offers;